import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FacebookFollowLink } from './FacebookFollowLink';

function cx(...parts) {
  return parts.filter(Boolean).join(' ');
}

function MoreIcon() {
  return (
    <svg
      className="header-more-menu__icon"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      aria-hidden="true"
    >
      <circle cx="10" cy="4.5" r="1.35" fill="currentColor" />
      <circle cx="10" cy="10" r="1.35" fill="currentColor" />
      <circle cx="10" cy="15.5" r="1.35" fill="currentColor" />
    </svg>
  );
}

export function HeaderMoreMenu() {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const location = useLocation();

  function closeMenu() {
    setOpen(false);
  }

  useEffect(() => {
    function handlePointerDown(e) {
      if (!rootRef.current?.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handlePointerDown);
    document.addEventListener('touchstart', handlePointerDown);
    return () => {
      document.removeEventListener('mousedown', handlePointerDown);
      document.removeEventListener('touchstart', handlePointerDown);
    };
  }, []);

  useEffect(() => {
    function handleKey(e) {
      if (e.key === 'Escape') {
        setOpen(false);
      }
    }
    if (open) {
      document.addEventListener('keydown', handleKey);
      return () => document.removeEventListener('keydown', handleKey);
    }
    return undefined;
  }, [open]);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <div className="header-more-menu" ref={rootRef}>
      <button
        type="button"
        className="header-more-menu__trigger"
        aria-expanded={open}
        aria-haspopup="true"
        aria-controls="header-more-menu-panel"
        aria-label="More site links"
        onClick={() => setOpen((v) => !v)}
      >
        <MoreIcon />
      </button>
      {open && (
        <div
          id="header-more-menu-panel"
          className="header-more-menu__panel"
          role="menu"
          aria-label="Site sections"
        >
          <Link
            to="/about"
            role="menuitem"
            className={cx(
              'header-more-menu__link',
              'results-page__nav-link',
              location.pathname === '/about' && 'results-page__nav-link--current',
            )}
            aria-current={location.pathname === '/about' ? 'page' : undefined}
            onClick={closeMenu}
          >
            About
          </Link>
          <Link
            to="/add-store"
            role="menuitem"
            className={cx(
              'header-more-menu__link',
              'results-page__nav-link',
              (location.pathname === '/add-store' ||
                location.pathname === '/add-store/apply') &&
                'results-page__nav-link--current',
            )}
            aria-current={
              location.pathname === '/add-store' ||
              location.pathname === '/add-store/apply'
                ? 'page'
                : undefined
            }
            onClick={closeMenu}
          >
            Add your store
          </Link>
          <FacebookFollowLink
            variant="menu"
            location="header_menu"
            className="header-more-menu__link"
            onClick={closeMenu}
          />
        </div>
      )}
    </div>
  );
}
